import React, { useEffect } from "react";
import { TweenLite } from "gsap";
import { isMobile, getFontSizeXD } from "../../utils";
import images from "./../../assets/images/images";
import config from "../../config";
import styles from "./styles";

function Sponsors({ animated, small, children }) {
  useEffect(() => {
    if (animated) {
      TweenLite.fromTo(
        "#sponsors-img",
        0.6,
        { opacity: 0 },
        { opacity: 1, delay: config.TRIGGER_DURATION }
      );
      TweenLite.fromTo(
        "#sponsor-desc",
        0.6,
        { opacity: 0 },
        { opacity: 1, delay: config.TRIGGER_DURATION + 0.6 }
      );
    }
  }, [animated]);

  const compact = small || isMobile();

  return (
    <div
      style={{
        ...styles.root,
        alignItems: small && !isMobile() ? "flex-start" : "center",
      }}
    >
      <div
        style={{
          ...styles.images,
          justifyContent: small ? "flex-start" : "center",
        }}
      >
        <img
          id={animated ? "sponsors-img" : ""}
          style={{
            display: "block",
            width: "100%",
            maxWidth: compact ? 320 : 720,
            height: "auto",
            opacity: animated ? 0 : 1,
          }}
          alt="Loghi cofinanziatori: Campania, Unione Europea, Repubblica Italiana, Regione Campania"
          src={images.sponsors}
        />
      </div>
      <div
        id={animated ? "sponsor-desc" : ""}
        style={{
          ...styles.description,
          opacity: animated ? 0 : 1,
          fontSize: getFontSizeXD(small ? 13 : 18),
          marginBottom: small ? 16 : 0,
          textAlign: small && !isMobile() ? "left" : "center",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default Sponsors;
